import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import { Modal } from 'bootstrap';

import { FileUpload, Input, Radio, TextArea, Datepicker, Editor } from "../../components/input";
import { SecondaryBtn, PrimaryBtn, TextBtn, Toggle } from "../../components/cta";
import LoaderImg from "../../assets/images/loader/mintd-loader.gif";
import Delete from "../../assets/images/modal/delete.svg";
import { NotificationConfirm } from '../../components/modal';
import SelectBox from '../../components/dropdown/selectBox';
import { Toast } from '../../components/note';
import { DataTable } from '../../components/dataFormating';


import APIPost from "../../services/postApi";
import devconfig from "../../config/config";
import APIGet from '../../services/getApi';
import moment from 'moment';

import style from '../../styles/components/searchInput.module.scss';

const NORMALIZED_SIP_DATES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];

const TIME_SLOT = [
    { value: '08:00:00AM', label: '08:00 AM' },
    { value: '09:00:00AM', label: '09:00 AM' },
    { value: '10:00:00AM', label: '10:00 AM' },
    { value: '11:00:00AM', label: '11:00 AM' },
    { value: '12:00:00PM', label: '12:00 PM' },
    { value: '01:00:00PM', label: '01:00 PM' },
    { value: '02:00:00PM', label: '02:00 PM' },
    { value: '03:00:00PM', label: '03:00 PM' },
    { value: '04:00:00PM', label: '04:00 PM' },
    { value: '05:00:00PM', label: '05:00 PM' },
    { value: '06:00:00PM', label: '06:00 PM' },
    { value: '07:00:00PM', label: '07:00 PM' },
];

// Local storage key used for draft saving
const LS_KEY = "email_notification_data"; // kept separate key but stored object uses same field names as WhatsApp where applicable

const STORED_DATA_EMAIL = {
    subject: "",
    // keep common naming for schedule/segment fields similar to WhatsApp
    emailContentType: 'BODY_CONTENT',
    emailContent: "",
    htmlFile: null,
    htmlFileName: "",
    image_url: "",
    attachments: [],
    type: 1,
    segment: null,
    signup: null,
    rebalance: null,
    repeat_day: null,
    send_later: false,
    start_date: null,
    end_date: null,
    time: null,
    frequency: null,
    week_day: null,
    month_day: null,
    users: [],
    custom_emails: [""],
    is_one_time: false,
};

const TABLE_COLUMN = [
    {
        name: 'User name',
        selector: row => row.customer_name,
        sortable: false,
        left: true,
        minWidth: '150px',
        cell: row => row.customer_name
    },
    {
        name: 'Mobile',
        selector: row => row.customer_phone,
        sortable: false,
        left: true,
        minWidth: '200px',
        cell: row => <span>{row.customer_phone ? row.customer_phone : '-'}</span>
    },
    {
        name: 'Email',
        selector: row => row.customer_name,
        sortable: false,
        left: true,
        minWidth: '200px',
        cell: row => <span>{row.customer_email ? row.customer_email : '-'}</span>
    },
]


const EmailMessage = (props) => {

    const searchRef = useRef(null);

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [attachments, setAttachments] = useState([""]);

    const [subject, setSubject] = useState("");     // ⭐ SUBJECT FIELD
    const [htmlFile, setHtmlFile] = useState(null);
    const [htmlFileName, setHtmlFileName] = useState("");

    const [uploadingIndex, setUploadingIndex] = useState(-1);
    const [type, setType] = useState(1);
    const [openPopup, setOpenPopup] = useState(false);
    const [csvLoader, setCsvLoader] = useState(false);

    const [emailContentType, setEmailContentType] = useState('BODY_CONTENT');
    const [emailContent, setEmailContent] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [bannerPreviewUrl, setBannerPreviewUrl] = useState("");
    const [bannerFileName, setBannerFileName] = useState("");
    const [bannerLoader, setBannerLoader] = useState(false);
    const fileInputRefs = useRef({});

    const [userUrl, setUserUrl] = useState("");
    const [csvName, setCsvName] = useState("");
    const [generalFilters, setGeneralFilters] = useState([]);
    const [sendLater, setSendLater] = useState(false);
    // rename local state variables to match WhatsApp naming for stored keys where appropriate
    const [selectedSegment, setSelectedSegment] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [addedTime, setAddedTime] = useState(null);
    const [selectedFrequency, setSelectedFrequency] = useState(null);
    const [selectedSignUpStatus, setSelectedSignUpStatus] = useState(null);
    const [selectedRebalanceStatus, setSelectedRebalanceStatus] = useState(null);
    const [selectedRepeatDay, setSelectedRepeatDay] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [repeatedDate, setRepeatedDate] = useState(null);
    const [selectedRepeatedDate, setSelectedRepeatedDate] = useState(null);
    const [selectedWeekDay, setSelectedWeekDay] = useState(null);
    const [loader, setLoader] = useState(false);
    const [notificationUsers, setNotificationUsers] = useState([]);
    const [notificationListLoader, setNotificationListLoader] = useState(false);
    const [htmlLoader, setHtmlLoader] = useState(false);
    const [openUsersList, setOpenUsersList] = useState(false);
    const [isOneTime, setIsOneTime] = useState(false);
    const [customEmails, setCustomEmails] = useState([""]);

    // ----------------- Retention store state -----------------
    const [storedData, setStoredData] = useState(STORED_DATA_EMAIL);

    // ---------------- Effects (mirrors WhatsApp retention behaviour) ----------------

    useEffect(() => {
        const shouldFetch =
            selectedSegment &&
            (
                (selectedSegment.value === 1 && selectedSignUpStatus) ||
                (selectedSegment.value === 5 && selectedRebalanceStatus)
            );
        if (shouldFetch) {
            _getNotificationUsers();
        }
    }, [selectedSegment, selectedSignUpStatus, selectedRebalanceStatus])

    useEffect(() => {
        _getGeneralFilters();
    }, []);


    // If editableData changes (edit flow), populate fields from API data (ignore localStorage)
    useEffect(() => {
        if (props.editableData !== null) {
            const data = props.editableData;
            // Support both shapes: data.contents.email_data (list) and data.email_data (detail/flat)
            const emailData = data?.contents?.email_data ?? data?.email_data;
            const customersList = Array.isArray(data?.customers_list)
                ? data.customers_list
                : (Array.isArray(data?.message_detail?.customers_list) ? data.message_detail.customers_list : []);

            if (emailData?.subject != null) {
                setSubject(emailData.subject);
                props.setPreviewTitle(emailData.subject);
            }
            if (emailData?.email_body) {
                props.setPreviewContent(emailData.email_body);
            }
            setEmailContent(emailData?.email_body ?? "");

            if (data?.message_detail?.csv_url !== null) {
                let file_name = data?.message_detail?.csv_url.split('/');
                setUserUrl(data?.message_detail?.csv_url);
                setCsvName(file_name[file_name.length - 1]);
            }

            setEmailContentType(emailData?.email_type);
            if (emailData?.html_content) {
                setHtmlFile(emailData.html_content);
                const file_name = emailData.html_content.split('/');
                props.setPreviewHTML(emailData.html_content);
                setHtmlFileName(file_name[file_name.length - 1]);
            }
            if (emailData?.image_url && emailData?.email_type === "BODY_CONTENT") {
                setImageUrl(emailData.image_url);
                setBannerPreviewUrl(emailData.image_url);
                props.setPreviewBanner && props.setPreviewBanner(emailData.image_url);
            }
            if (emailData?.email_attachment != null) {
                setAttachments(emailData.email_attachment || []);
                const arr = (emailData.email_attachment || []).filter(a => a && a.trim());
                if (arr.length > 0) {
                    props.setPreviewImage(arr);
                    const typeDetected = detectMediaTypeFromUrl(arr[0]);
                    props.updateMediaType(typeDetected);
                }
            }

            const isType4 = data?.message_detail?.type === 4;
            const hasCustomersList = customersList.length > 0;
            const hasAnyEmail = hasCustomersList && customersList.some(c => (c && (c.customer_email || c.email)));
            if (isType4 || hasAnyEmail) {
                setType(4);
                const toEmailFromCustomer = (c) => {
                    const v = c && (c.customer_email || c.email);
                    return v ? String(v).trim() : "";
                };
                const toEmailFromCustom = (e) => {
                    if (typeof e === "string") return e;
                    const v = e && (e.email || e.value);
                    return v ? String(e.email || e.value) : "";
                };
                const fromCustomers = hasCustomersList ? customersList.map(toEmailFromCustomer).filter(Boolean) : [];
                const fromCustomValues = Array.isArray(data?.message_detail?.custom_values) && data.message_detail.custom_values.length > 0
                    ? data.message_detail.custom_values.map(toEmailFromCustom).filter(Boolean) : [];
                const emailList = fromCustomers.length > 0 ? fromCustomers : fromCustomValues;
                setCustomEmails(emailList.length > 0 ? emailList : [""]);
            } else {
                setType(data?.message_detail?.type ?? 1);
            }
            if (data?.message_detail?.type === 3) {
                setSelectedSegment({ value: data?.message_detail?.segment_type, label: data?.message_detail?.segment_type_variable })
            }
            if (data?.message_detail?.segment_type === 5) {
                setSelectedRebalanceStatus({ value: data?.message_detail?.segment_type_option, label: data?.message_detail?.segment_type_option_variable })
            }
            if (data?.message_detail?.segment_type === 1) {
                setSelectedSignUpStatus({ value: data?.message_detail?.segment_type_option, label: data?.message_detail?.segment_type_option_variable });
            }

            if (data?.message_detail?.segment_days) {
                setSelectedRepeatDay(data?.message_detail?.segment_days);
            }

            if (data?.scheduled_date !== undefined && data?.scheduled_date !== null && data?.scheduled_date !== "") {
                setSendLater(true);
                if (data?.message_detail?.start_date) {
                    setStartDate(moment(data?.message_detail?.start_date).format("DD-MM-YYYY"));
                }
                if (data?.message_detail?.end_date) {
                    setEndDate(moment(data?.message_detail?.end_date).format("DD-MM-YYYY"));
                }
                if (data?.message_detail?.time) {
                    let rawTime = data?.message_detail?.time;
                    let cleaned = rawTime?.replace(/\s/g, '');
                    let time = TIME_SLOT.find(item => item.value === cleaned)

                    setAddedTime(time);
                }
                if (data?.message_detail?.frequency) {
                    setSelectedFrequency({ value: data?.message_detail?.frequency, label: data?.message_detail?.frequency_var });
                }
                if (data?.message_detail?.frequency === 1) {
                    let day = generalFilters?.repeat_day?.find(item => item.value === data?.message_detail?.repeat_day);
                    setSelectedWeekDay(day)
                } else {
                    if (data?.message_detail?.repeat_date) {
                        setSelectedRepeatedDate(data?.message_detail?.repeat_date);
                        setRepeatedDate({
                            label: _formatSip(data?.message_detail?.repeat_date),
                            value: data?.message_detail?.repeat_date
                        })
                    }
                }
                setIsOneTime(data?.message_detail?.is_one_time);
            }

        }
    }, [props.editableData, generalFilters]);

    useEffect(() => {
        if (!startDate || !isOneTime) return;

        const now = moment();
        const isToday = moment(startDate, "DD-MM-YYYY").isSame(moment(), "day");
        const cutoffTime = moment("07:00:00PM", "hh:mm:ssA");

        if (isToday && now.isSameOrAfter(cutoffTime)) {
            setError("No time available for today");
        } else {
            setError("");
        }
    }, [startDate, isOneTime]);

    // ---------------- Retention helpers (same pattern as WhatsApp) ----------------

    // Supports either (_updateStore(key, value)) or (_updateStore(null, {a:1, b:2}))
    const _updateStore = (key, value) => {
        setStoredData(prev => {
            const updated = key ? { ...prev, [key]: value } : { ...prev, ...value };
            try {
                localStorage.setItem(LS_KEY, JSON.stringify(updated));
            } catch (e) {
                console.warn("Failed to write draft to localStorage", e);
            }
            return updated;
        });
    };

    const detectMediaTypeFromUrl = (url) => {
        if (!url || typeof url !== "string") return null;

        // Clean the URL (remove query params)
        const cleanUrl = url.split("?")[0];

        // Extract extension
        const extension = cleanUrl.split(".").pop().toLowerCase();

        // Image extensions → type 1
        const imageExt = ["jpg", "jpeg", "png", "gif", "webp", "svg"];
        const videoExt = ["mpeg4", "mp4"];


        // Docs / PDF / CSV / HTML → type 3
        const docExt = ["pdf", "doc", "docx", "xls", "xlsx", "csv"];

        if (imageExt.includes(extension)) return 1;
        if (videoExt.includes(extension)) return 2;
        if (docExt.includes(extension)) return 3;

        // fallback → treat unknown as doc type
        return 3;
    };

    const _clearStore = () => {
        try {
            localStorage.removeItem(LS_KEY);
        } catch (e) {
            console.warn("Failed to clear draft store", e);
        }
        setStoredData(STORED_DATA_EMAIL);
    };

    // Restore draft from localStorage only if NOT editing existing message
    useEffect(() => {
        try {
            const saved = localStorage.getItem(LS_KEY);

            if (saved && !props.editableData) {
                const data = JSON.parse(saved);

                // Restore subject
                setSubject(data.subject || "");
                if (data.subject !== "") {
                    props.setPreviewTitle(data?.subject);
                }

                // Restore email content / html

                if (data.emailContent) {
                    props.setPreviewContent(data.emailContent);
                }
                setEmailContent(data.emailContent ?? "");

                setEmailContentType(data.emailContentType || 'BODY_CONTENT');

                setHtmlFile(data.htmlFile || null);
                if (data.htmlFile) {
                    props.setPreviewHTML(data?.htmlFile);
                }
                setHtmlFileName(data.htmlFileName || "");

                if ((data.emailContentType || "BODY_CONTENT") === "BODY_CONTENT") {
                    setImageUrl(data.image_url || "");
                    setBannerPreviewUrl(data.image_url || "");
                    if (data.image_url) {
                        props.setPreviewBanner && props.setPreviewBanner(data.image_url);
                    }
                } else {
                    setImageUrl("");
                    setBannerPreviewUrl("");
                    props.setPreviewBanner && props.setPreviewBanner(null);
                }

                // attachments
                setAttachments(data.attachments || [""]);

                if (data.attachments.length) {
                    setAttachments(data.attachments);
                    const arr = data.attachments;
                    if (arr.length > 0) {
                        props.setPreviewImage(arr);
                        const typeDetected = detectMediaTypeFromUrl(arr[0]);
                        props.updateMediaType(typeDetected);
                    }
                }

                // Restore CSV / URL
                setUserUrl(data.userUrl || data.csv_url || "");
                setCsvName(data.csvName || "");

                // Restore targeting (we'll remap segment/signup/rebalance after filters load)
                setType(data.type || 1);

                if (data.segment) setSelectedSegment(data.segment);
                if (data.signup) setSelectedSignUpStatus(data.signup);
                if (data.rebalance) setSelectedRebalanceStatus(data.rebalance);
                setSelectedRepeatDay(data.repeat_day || null);

                // Restore scheduling
                setSendLater(data.send_later || false);
                setStartDate(data.start_date || null);
                setEndDate(data.end_date || null);
                setAddedTime(data.time || null);
                setSelectedFrequency(data.frequency || null);
                setSelectedWeekDay(data.week_day || null);

                if (data.month_day) {
                    setSelectedRepeatedDate(data.month_day);
                    setRepeatedDate({
                        label: _formatSip(data.month_day),
                        value: data.month_day
                    });
                }
                setIsOneTime(data.is_one_time);
                setNotificationUsers(data.users || []);
                setCustomEmails(Array.isArray(data.custom_emails) && data.custom_emails.length > 0 ? data.custom_emails : [""]);
                setStoredData({ ...STORED_DATA_EMAIL, ...data });
            }
        } catch (e) {
            console.warn("Failed to restore draft", e);
        }
    }, [props.editableData]);

    // After generalFilters load (or change), remap stored segment/signup/rebalance to actual option objects
    useEffect(() => {
        if (props.editableData) return; // ignore when editing an existing message

        try {
            const savedStr = localStorage.getItem(LS_KEY);
            if (!savedStr || !generalFilters || Object.keys(generalFilters).length === 0) return;
            const saved = JSON.parse(savedStr);

            // Helper: accepts either stored object {value,label} or primitive value
            const resolveOption = (list, stored) => {
                if (!list || !stored) return null;
                const storedValue = typeof stored === "object" && stored.value !== undefined ? stored.value : stored;
                return list.find(i => Number(i.value) === Number(storedValue)) || null;
            };

            const seg = resolveOption(generalFilters.segment_type, saved.segment);
            if (seg) setSelectedSegment(seg);

            const su = resolveOption(generalFilters.signup_staus, saved.signup);
            if (su) setSelectedSignUpStatus(su);

            const rb = resolveOption(generalFilters.rebalance_status, saved.rebalance);
            if (rb) setSelectedRebalanceStatus(rb);
        } catch (e) {
            // ignore
        }
    }, [generalFilters, props.editableData]);

    // ---------------- UI helpers / form reset updated to clear localstore ----------------

    const _showConfirmation = () => {
        const modal = new Modal(document.getElementById("pushConfirm"));
        modal.show();
    }


    const _resetForm = () => {
        setAttachments([""]);
        setSubject("");
        setImageUrl("");
        setBannerPreviewUrl("");
        setBannerFileName("");
        props.setPreviewTitle(null);
        props.setPreviewHTML(null);
        props.setPreviewContent(null);
        props.setPreviewBanner && props.setPreviewBanner(null);
        props.setPreviewImage([]);
        setType(1);
        setHtmlFile(null);
        setEmailContent("");
        setSelectedSegment(null);
        setSelectedSignUpStatus(null);
        setSelectedRebalanceStatus(null);
        setSelectedRepeatDay(null);
        setNotificationUsers([]);
        setCustomEmails([""]);
        setSendLater(false);
        setStartDate(null);
        setEndDate(null);
        setAddedTime(null);
        setSelectedFrequency(null);
        setSelectedRepeatedDate(null);
        setRepeatedDate(null);
        setSelectedWeekDay(null);

        setOpenPopup(false);

        // Clear stored draft when resetting the form
        _clearStore();
    };

    const _formatSip = (selected_date) => {
        switch (selected_date) {
            case 1: return "1st of every month";
            case 2: return "2nd of every month";
            case 3: return "3rd of every month";
            case 21: return "21st of every month";
            case 22: return "22nd of every month";
            case 23: return "23rd of every month";
            default: return selected_date + "th of every month";
        };
    }

    const disabledDate = (current) => {
        if (!current) return false; // safety

        // compare only by day (ignore time-of-day)
        const today = moment().startOf('day');

        // parse startDate using the same format you store it in (DD-MM-YYYY)
        const _startDate = startDate ? moment(startDate, 'DD-MM-YYYY').startOf('day') : null;

        // If startDate exists → disable all dates <= startDate (includes startDate)
        if (_startDate && _startDate.isValid()) {
            return current.isSameOrBefore(_startDate, 'day');
        }

        // If no startDate → disable past dates including today
        return current.isSameOrBefore(today, 'day');
    };

    // ---------------- ADD NEW ATTACHMENT ----------------
    const addAttachment = () => {
        if (attachments?.length >= 10) return;

        const next = [...attachments, ""];
        setAttachments(next);
        _updateStore('attachments', next);
    };

    // ---------------- REMOVE ATTACHMENT ----------------
    const removeAttachment = (index) => {
        const next = attachments.filter((_, i) => i !== index);
        props.setPreviewImage(next);
        setAttachments(next);
        _updateStore('attachments', next);
    };

    const clearBanner = () => {
        setImageUrl("");
        setBannerPreviewUrl("");
        setBannerFileName("");
        props.setPreviewBanner && props.setPreviewBanner(null);
        _updateStore('image_url', "");
    };

    const uploadBanner = (file) => {
        if (!file) return;
        setBannerFileName(file.name);
        setBannerLoader(true);

        const url = devconfig.admin + "/file/upload";
        const data = JSON.stringify({
            file: file.name,
            is_public: true,
        });

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                uploadToS3(response.data, file, 3, -1);
            } else {
                setBannerLoader(false);
            }
        }).catch(() => setBannerLoader(false));
    };

    // ---------------- UPLOAD FILE (AWS) ----------------
    const uploadAttachment = (file, type, index) => {
        const _startUpload = () => {
            if (type === 1) {
                setHtmlLoader(true);
            }
            setUploadingIndex(index);

            const url = devconfig.admin + "/file/upload";

            const data = JSON.stringify({
                file: file.name,
                is_public: true,
            });

            APIPost(url, data).then((response) => {
                if (response.status_code === 200) {
                    uploadToS3(response.data, file, type, index);
                } else {
                    setUploadingIndex(-1);
                }
            });
        };
        if (type === 2 && file?.type?.startsWith("image/")) {
            let preview = URL.createObjectURL(file);
            const img = new Image();
            img.onload = () => {
                URL.revokeObjectURL(preview);
                if (img.naturalWidth !== 1122 || img.naturalHeight !== 1402) {
                    setError("Please upload an image with dimensions 1122 × 1402 px.");
                    return;
                }
                _startUpload();
            };
            img.onerror = () => {
                URL.revokeObjectURL(preview);
                setError("Unable to read the image file");
            };
            img.src = preview;
            return;
        }

        _startUpload();
    };

    const uploadToS3 = (data, file, type, index) => {
        const formdata = new FormData();

        Object.keys(data.upload_info.fields).forEach(key => {
            formdata.append(key, data.upload_info.fields[key]);
        });

        formdata.append("file", file, file.name);

        fetch(data.upload_info.url, { method: "POST", body: formdata })
            .then(() => {
                if (type === 1) {
                    setHtmlFile(data.view_info);
                    setHtmlFileName(file.name);
                    props.setPreviewHTML(data.view_info);
                    _updateStore('htmlFile', data.view_info);
                    _updateStore('htmlFileName', file.name);
                    setHtmlLoader(false);
                } else if (type === 3) {
                    setImageUrl(data.view_info);
                    setBannerPreviewUrl(data.view_info);
                    props.setPreviewBanner && props.setPreviewBanner(data.view_info);
                    _updateStore('image_url', data.view_info);
                    setBannerLoader(false);
                } else {
                    let arr = [...attachments];
                    arr[index] = data.view_info;
                    if (arr.length > 0) {
                        props.setPreviewImage(arr);
                        const typeDetected = detectMediaTypeFromUrl(arr[0]);
                        props.updateMediaType(typeDetected);
                    }
                    setAttachments(arr);
                    setUploadingIndex(-1);
                    _updateStore('attachments', arr);
                }

            })
            .catch(() => {
                if (type === 3) {
                    setBannerLoader(false);
                } else {
                    setUploadingIndex(-1);
                }
            });
    };

    const _uploadFile = (temp) => {
        setCsvLoader(true);
        let url = devconfig.admin + '/file/upload'

        let data = JSON.stringify({
            file: temp.name,
            is_public: true,
        })

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setCsvLoader(true);
                _uploadDocument(response.data, temp); // upload file in AWS s3
            } else {
                setError(response.message);
                setCsvLoader(false);
            }
        })
    }

    const _uploadDocument = async (data, file) => {
        setCsvLoader(true);
        var formdata = new FormData();
        formdata.append("key", data.upload_info.fields.key);
        formdata.append("x-amz-algorithm", data.upload_info.fields['x-amz-algorithm']);
        formdata.append("x-amz-credential", data.upload_info.fields['x-amz-credential']);
        formdata.append("x-amz-date", data.upload_info.fields['x-amz-date']);
        formdata.append("policy", data.upload_info.fields['policy']);
        formdata.append("x-amz-signature", data.upload_info.fields['x-amz-signature']);
        formdata.append("file", file, file.name);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        };

        fetch(data.upload_info.url, requestOptions)
            .then(response => response.text())
            .then(result => {
                setCsvLoader(false);
                setUserUrl(data.view_info);
                setCsvName(file.name);
                _updateStore(null, { userUrl: data.view_info, csvName: file.name });
            })
            .catch(error => {
                // console.log('error', error); // show error toast here
            });
    }

    const _getNotificationUsers = () => {
        setNotificationListLoader(true);
        const url = devconfig.admin + '/notification/get-users';
        let payload = JSON.stringify({
            segment_type: selectedSegment?.value,
            segment_type_option: selectedSegment?.value === 1 ? selectedSignUpStatus?.value : selectedSegment?.value === 5 ? selectedRebalanceStatus?.value : null,
            segment_days: selectedSegment?.value !== 1 && selectedSegment.value !== 5 ? Number(selectedRepeatDay) : null,
        });
        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setNotificationUsers(response.data);
                _updateStore('users', response.data);
            } else {
                setNotificationUsers([]);
                _updateStore('users', []);
            }
            setNotificationListLoader(false);
        })
    }

    // ---- Get API filters
    const _getGeneralFilters = () => {
        const url = devconfig.admin + '/notification/filter-data';
        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                const transformedData = {};

                Object.keys(response.data).forEach((key) => {
                    const item = response.data[key];

                    // Case 1: If value is an array
                    if (Array.isArray(item)) {
                        transformedData[key] = item.map((obj) => ({
                            value: obj.id,
                            label: obj.label
                        }));
                    }

                    // Case 2: If value is an object (repeat_day, repeat_frequency)
                    else if (typeof item === "object" && item !== null) {
                        transformedData[key] = Object.keys(item).map((id) => ({
                            value: Number(id),
                            label: item[id]
                        }));
                    }

                    // Case 3: Anything else pass as it is
                    else {
                        transformedData[key] = item;
                    }
                });
                setGeneralFilters(transformedData)
            }
        })
    }

    /*----- send global notification api ---*/
    const _sendGlobalNotification = () => {
        let cleanAttachments = attachments.filter(a => a && a.trim() !== "");
        setLoader(true);
        let api_url = props.sendAgain ? devconfig.admin + '/notification/v2/send-global' : props.editableData !== null ? devconfig.admin + '/notification/edit-scheduled-notification' : devconfig.admin + '/notification/v2/send-global';
        let schedule_data = sendLater ? {
            is_one_time: isOneTime,
            start_date: startDate,
            end_date: endDate,
            frequency: selectedFrequency?.value,
            repeat_day: selectedWeekDay?.value,
            repeat_date: repeatedDate?.value,
            time: addedTime?.value
        } : null;
        const customValues = type === 4
            ? customEmails.filter(e => (e || "").trim() !== "").map(e => e.trim())
            : null;
        let data = JSON.stringify({
            channel: 3,
            schedule_id: props.editableData !== null ? props.editableData.id : null,
            type: type,
            csv_url: type === 4 ? null : userUrl,
            segment_type: type === 4 ? null : selectedSegment?.value,
            segment_type_option: type === 4 ? null : (selectedSignUpStatus?.value || selectedRebalanceStatus?.value),
            segment_days: type === 4 ? null : selectedRepeatDay,
            ...(type === 4 && customValues && customValues.length > 0 ? { custom_values: customValues } : {}),
            notification_data: null,
            schedule_message: schedule_data,
            whatsapp_data: null,
            email_data: {
                subject: subject,
                email_type: emailContentType,
                email_body: emailContent,
                html_content: htmlFile,
                email_attachment: cleanAttachments,
                image_url: emailContentType === "BODY_CONTENT" ? (imageUrl || null) : null
            }
        });


        APIPost(api_url, data).then((response) => {
            if (response.status_code === 200) {
                if (props.editableData !== null) {
                    setSuccess("Email has been updated");
                    props.updateSuccess(3);
                    // clear draft because edit flow saved
                    _clearStore();
                } else {
                    const recipientCount = type === 4 ? customValues?.length : (notificationUsers?.length ?? 0);
                    const recipientLabel = type === 4 ? "custom recipient(s)" : "users";
                    if (sendLater) {
                        setSuccess(`This message will be sent to ${type === 1 ? "All users" : `the selected ${recipientCount ? recipientCount + " " : ""}${recipientLabel}`}. An intimation mail will send to the admin once it finishes sending the message to the selected user.`);
                    } else {
                        setSuccess(`This message will be sent to ${type === 1 ? "All users" : `the selected ${recipientCount ? recipientCount + " " : ""}${recipientLabel}`}. An intimation mail will send to the admin once it finishes sending the message to the selected user.`);
                    }

                    // Keep fields + draft populated so the admin can send a test to themselves
                    // first and then re-send the same content to clients without re-entering it.
                    // _resetForm();
                    // _clearStore();
                }
                setLoader(false);
            } else {
                setError(response.message);
                setLoader(false);
            }
        });
    }

    async function getFileDetails(url) {
        // Extract file name
        const cleanUrl = url.split("?")[0];
        const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);

        // Extract extension
        const extension = cleanUrl.split(".").pop().toLowerCase();

        // Type mappings
        const imageExt = ["jpg", "jpeg", "png", "gif", "webp", "svg"];
        const videoExt = ["mp4", "mov", "webm", "mkv"];
        const audioExt = ["mp3", "wav", "ogg"];
        const pdfExt = ["pdf"];
        const docExt = ["doc", "docx", "xls", "xlsx", "csv"];

        // 1 → image
        if (imageExt.includes(extension)) return { type: 1, fileName };

        // 2 → video
        if (videoExt.includes(extension)) return { type: 2, fileName };

        // 3 → audio
        if (audioExt.includes(extension)) return { type: 3, fileName };

        // 4 → pdf
        if (pdfExt.includes(extension)) return { type: 4, fileName };

        // 5 → docs
        if (docExt.includes(extension)) return { type: 5, fileName };

        // If extension missing → try HEAD request
        try {
            const response = await fetch(url, { method: "HEAD" });
            const contentType = response.headers.get("content-type");

            if (!contentType) return { type: 0, fileName };

            if (contentType.startsWith("image/")) return { type: 1, fileName };
            if (contentType.startsWith("video/")) return { type: 2, fileName };
            if (contentType.startsWith("audio/")) return { type: 3, fileName };
            if (contentType === "application/pdf") return { type: 4, fileName };
            if (
                contentType.includes("word") ||
                contentType.includes("excel") ||
                contentType.includes("presentation")
            ) return { type: 5, fileName };

            return { type: 0, fileName }; // unknown
        } catch (error) {
            return { type: 0, fileName }; // unknown
        }
    }

    const FileRenderer = ({ url }) => {
        const [info, setInfo] = useState({ type: 0, fileName: "" });

        useEffect(() => {
            if (url) {
                getFileDetails(url).then(res => setInfo(res));
            }
        }, [url]);

        if (info.type === 1)
            return <img src={url} width="100%" height="100%" style={{ objectFit: "contain" }} />;

        if (info.type === 2)
            return <video src={url} width="100%" height="100%" controls={false} loop autoPlay style={{ objectFit: "contain" }} />;

        if (info.type === 3)
            return <audio controls src={url} />;

        if (info.type === 4)
            return <a href={url} className='e-csv-file' target="_blank" rel="noreferrer">{info.fileName}</a>;

        if (info.type === 5)
            return <a href={url} className='e-csv-file' target="_blank" rel="noreferrer">{info.fileName}</a>;

        return <p>Unsupported file</p>;
    };

    const _getAvailableTime = (isOneTime) => {
        if (!isOneTime && !startDate) return TIME_SLOT;

        const now = moment();
        const isToday =
            startDate &&
            moment(startDate, "DD-MM-YYYY").isSame(moment(), "day");

        const cutoffTime = moment("07:00:00PM", "hh:mm:ssA");

        if (isToday) {
            if (now.isSameOrAfter(cutoffTime)) {
                return []; // ❌ no state update here
            }

            return TIME_SLOT.filter((slot) =>
                moment(slot.value, "hh:mm:ssA").isAfter(now)
            );
        }

        return TIME_SLOT;
    };



    return (
        <div className="row px-2">

            {/* ⭐ SUBJECT INPUT */}
            <div className="col-12">
                <label>Subject*</label>
                <Input
                    placeholder="Add subject"
                    value={subject}
                    valueChange={(value) => { setSubject(value); props.setPreviewTitle(value); _updateStore('subject', value); }}
                />
            </div>

            <div className="col-12 ">
                <div className="col-12 d-flex align-items-center ">
                    <label className="me-3 pb-0">Add</label>
                    <Radio id="BODY_CONTENT" value="BODY_CONTENT" label="Body" checked={emailContentType === "BODY_CONTENT"}
                        valueClick={() => {
                            setEmailContentType("BODY_CONTENT");
                            _updateStore('emailContentType', 'BODY_CONTENT');
                            _updateStore('emailContent', "");
                            _updateStore('htmlFile', null);
                            _updateStore('htmlFileName', "");
                            props.setPreviewContent(null);
                            props.setPreviewHTML(null);
                            setEmailContent("");
                            setHtmlFile(null);
                            setHtmlFileName("")
                        }} />
                    <Radio id="HTML_CONTENT" value="HTML_CONTENT" label="Upload HTML file" checked={emailContentType === "HTML_CONTENT"}
                        valueClick={() => {
                            setEmailContentType("HTML_CONTENT");
                            _updateStore('emailContentType', 'HTML_CONTENT');
                            _updateStore('emailContent', "");
                            _updateStore('htmlFile', null);
                            _updateStore('htmlFileName', "");
                            props.setPreviewContent(null);
                            props.setPreviewHTML(null);
                            setEmailContent("");
                            setHtmlFile(null);
                            setHtmlFileName("");
                            clearBanner();
                        }} />
                </div>
            </div>

            {/* Upload HTML File */}
            {
                emailContentType === "BODY_CONTENT" ?
                    <>
                        <div className="col-lg-12 pe-0 mb-4">
                            <label>Inline Image (1408 × 768)</label>
                            {
                                bannerPreviewUrl ?
                                    <div className="e-inline-image-preview position-relative text-center">
                                        <img
                                            src={Delete}
                                            alt="delete"
                                            width="32"
                                            className="position-absolute e-delete-image"
                                            style={{ right: 16, cursor: "pointer" }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                clearBanner();
                                            }}
                                        />
                                        {
                                            bannerLoader ?
                                                <img src={LoaderImg} height="40px" alt="" />
                                                :
                                                <div className="e-inline-image-preview__frame">
                                                    <img
                                                        src={bannerPreviewUrl}
                                                        alt="Inline image"
                                                        className="e-inline-image-preview__img"
                                                    />
                                                </div>
                                        }
                                    </div>
                                    :
                                    <div
                                        className="e-uploader mb-2"
                                        onClick={() => fileInputRefs.current.banner && fileInputRefs.current.banner.click()}
                                    >
                                        <p className="text-center mb-2">
                                            {bannerFileName || "Upload an image"}
                                        </p>
                                        {
                                            bannerLoader ?
                                                <img src={LoaderImg} height="40px" alt="" />
                                                : null
                                        }
                                    </div>
                            }
                            <input
                                type="file"
                                accept="image/png,image/jpeg,image/jpg,image/webp"
                                className="d-none"
                                ref={(el) => (fileInputRefs.current.banner = el)}
                                onChange={(e) => {
                                    uploadBanner(e.target.files[0]);
                                    e.target.value = "";
                                }}
                            />
                        </div>

                        <div className="col-lg-12 pe-0 mb-4">
                        <label>Email body</label>
                        {/* <TextArea
                            placeholder="Content of email"
                            value={emailContent}
                            className="e-notification-form-element"
                            rows="3"
                            valueChange={(temp) => {
                                setEmailContent(temp);
                                props.setPreviewContent(temp);
                                _updateStore('emailContent', temp);
                            }}
                        /> */}
                        <Editor
                            editorChange={(temp) => {
                                setEmailContent(temp);
                                props.setPreviewContent(temp);
                                _updateStore('emailContent', temp);
                            }} value={emailContent} />
                    </div>
                    </>
                    :
                    <div className="col-12 mb-4">
                        <label>Upload file</label>

                        <div className="e-uploader position-relative" onClick={() => fileInputRefs.current["html"].click()}>
                            {
                                htmlFile ?
                                    <img
                                        src={Delete}
                                        alt="delete"
                                        width="32"
                                        className="position-absolute e-delete-image"
                                        style={{ right: 16, cursor: "pointer" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setHtmlFile(null);
                                            setHtmlFileName("");
                                            props.setPreviewHTML(null);
                                            _updateStore('htmlFile', null);
                                            _updateStore('htmlFileName', "");
                                        }}
                                    />
                                    : null
                            }
                            {
                                htmlLoader ?
                                    <p className="text-center ">
                                        <img src={LoaderImg} height="40px" />
                                    </p>
                                    :
                                    <p className="text-center mb-2">
                                        {htmlFile ? htmlFileName : "Upload HTML file here"}
                                    </p>
                            }

                        </div>

                        <input
                            type="file"
                            accept=".html"
                            className="d-none"
                            ref={(el) => (fileInputRefs.current["html"] = el)}
                            onChange={(e) => uploadAttachment(e.target.files[0], 1)}
                        />
                    </div>
            }


            {/* Attachments */}
            {attachments?.map((item, index) => (
                <div key={item.id || index} className={index > 0 ? "border-top pt-3 mb-4" : "mb-4"}>

                    <div className="d-flex justify-content-between">
                        <label>Upload Image (1122 × 1402 px)</label>

                        {index > 0 && (
                            <p
                                className="e-remove-attachment"
                                onClick={() => removeAttachment(index)}
                            >
                                Remove attachment
                            </p>
                        )}
                    </div>

                    <div
                        className="e-uploader e-preview position-relative text-center"
                        onClick={() => fileInputRefs.current[index].click()}
                    >
                        {/* Remove image */}
                        {
                            item ?
                                <img
                                    src={Delete}
                                    alt="delete"
                                    width="32"
                                    className="position-absolute e-delete-image"
                                    style={{ right: 16, cursor: "pointer" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        let arr = [...attachments];
                                        arr[index] = "";
                                        let content_array = arr
                                            .filter(item => item !== "");
                                        props.setPreviewImage(content_array);
                                        setAttachments(arr);
                                        _updateStore('attachments', arr);
                                    }}
                                />
                                : null
                        }

                        {uploadingIndex === index ? (
                            <img src={LoaderImg} height="40px" />
                        ) : item ? (
                            <FileRenderer url={item} />
                        ) : (
                            <p className="text-center mt-4 pt-2 mb-2">Upload attachment</p>
                        )}
                    </div>

                    <input
                        type="file"
                        accept="image/*,.pdf,.csv"
                        className="d-none"
                        ref={(el) => (fileInputRefs.current[index] = el)}
                        onChange={(e) => uploadAttachment(e.target.files[0], 2, index)}
                    />

                </div>
            ))}

            {/* Add attachment */}
            {attachments?.length < 10 && (
                <p className="e-add-attachment-btn" onClick={addAttachment}>
                    + Add new attachment
                </p>
            )}

            {/* Target Audience */}
            <div className="col-12">
                <label className="d-block mb-2 pb-0">Target audience</label>
                <div className="d-flex align-items-center flex-wrap" >
                    <Radio id="all" value={1} label="All" checked={type === 1} valueClick={() => { setType(1); setNotificationUsers([]); setCustomEmails([""]); _updateStore(null, { type: 1, users: [], custom_emails: [""] }); }} />
                    <Radio id="upload" value={2} label="Upload segment" checked={type === 2} valueClick={() => { setType(2); setNotificationUsers([]); setCustomEmails([""]); _updateStore(null, { type: 2, users: [], custom_emails: [""] }); }} />
                    <Radio id="select" value={3} label="Select segment" checked={type === 3} valueClick={() => { setType(3); setNotificationUsers([]); setCustomEmails([""]); _updateStore(null, { type: 3, users: [], custom_emails: [""] }); }} />
                    <Radio id="custom_value" value={4} label="Custom value" checked={type === 4} valueClick={() => { setType(4); setNotificationUsers([]); setCustomEmails(customEmails.length ? customEmails : [""]); _updateStore(null, { type: 4, users: [], custom_emails: customEmails.length ? customEmails : [""] }); }} />
                </div>
            </div>

            {type === 4 && (
                <div className="col-12 mt-2 mb-3">
                    <div className="d-flex flex-wrap  align-items-flex-start gap-2">
                        {customEmails.map((email, index) => {
                            const trimmed = (email || "").trim();
                            const hasValue = trimmed !== "";
                            const isValid = !hasValue || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
                            const canDelete = customEmails.length > 1;
                            return (
                                <div key={index} className="d-flex flex-column gap-0" style={{ flex: "0 0 calc(50% - 4px)", minWidth: "calc(50% - 4px)", maxWidth: "100%" }}>
                                    <div className="d-flex align-items-center gap-1">
                                        <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                            <Input
                                                type="email"
                                                placeholder="Enter email"
                                                value={email}
                                                valueChange={(val) => {
                                                    const next = [...customEmails];
                                                    next[index] = val;
                                                    setCustomEmails(next);
                                                    _updateStore('custom_emails', next);
                                                }}
                                                className={`e-notification-form-element ${hasValue && !isValid ? "border-danger" : ""}`}
                                            />
                                        </div>
                                        {canDelete && (
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-danger text-decoration-none d-flex align-items-center justify-content-center"
                                                style={{ flexShrink: 0 }}
                                                onClick={() => {
                                                    const next = customEmails.length > 1 ? customEmails.filter((_, i) => i !== index) : [""];
                                                    setCustomEmails(next);
                                                    _updateStore('custom_emails', next);
                                                }}
                                                title="Remove email"
                                            >
                                                <img src={Delete} alt="Remove" width={18} height={18} />
                                            </button>
                                        )}
                                    </div>
                                    <div className="mt-1" style={{ minHeight: "20px" }}>
                                        {hasValue && !isValid && (
                                            <small className="text-danger" style={{ fontSize: "11px", display: "block" }}>Please enter valid email address.</small>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                        <button
                            type="button"
                            className="btn btn-link p-0 mb-4 text-primary text-decoration-none"
                            disabled={
                                customEmails.some(e => (e || "").trim() === "") ||
                                customEmails.some(e => (e || "").trim() !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || "").trim()))
                            }
                            onClick={() => {
                                const trimmed = customEmails.map(e => (e || "").trim());
                                if (trimmed.some(t => t === "") || trimmed.some(t => t !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t))) return;
                                const next = [...customEmails, ""];
                                setCustomEmails(next);
                                _updateStore('custom_emails', next);
                            }}
                        >
                            + Add new email
                        </button>
                    </div>
                </div>
            )}

            {
                type === 3 ?

                    <div className='col-12 mt-2 mb-3'>
                        <SelectBox
                            value={selectedSegment}
                            placeholder="Choose segment"
                            options={generalFilters?.segment_type}
                            selectchange={(temp) => {
                                setSelectedSegment(temp);
                                setNotificationUsers([]);
                                _updateStore({ 'date': null, 'segment': temp });
                                setSelectedRepeatDay(null);
                                _updateStore('users', []);
                            }} />
                    </div>

                    : type === 2 ?
                        <div className='col-lg-12'>
                            <label>Upload csv url</label>

                            <div className="e-uploader mb-4 position-relative" onClick={() => { $('#e-csv-upload').click() }}>
                                {
                                    csvName ?
                                        <img src={Delete} alt="delete"
                                            width={"32px"} className='position-absolute e-delete-image' style={{ right: "15px", top: "10px", cursor: "pointer" }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setCsvName("");
                                                setUserUrl("");
                                                _updateStore(null, { csvName: "", userUrl: "" });
                                            }} />
                                        :
                                        null
                                }
                                <div className='text-center'>

                                    <p className='text-center mb-2'>
                                        {
                                            csvName ? csvName : "Upload csv file"
                                        }
                                    </p>
                                </div>
                                <FileUpload
                                    accept={".csv"}
                                    className="d-none"
                                    id="e-csv-upload"
                                    key="e-upload-image"
                                    upload={(temp) => {
                                        _uploadFile(temp)
                                    }} />
                            </div>
                        </div>
                        :
                        null
            }

            {
                selectedSegment && type === 3 && (
                    <>
                        {
                            selectedSegment?.value === 1 ?
                                <div className='col=12 mt-2 mb-3'>
                                    <label>Select signup status</label>
                                    <SelectBox
                                        value={selectedSignUpStatus}
                                        placeholder="Choose signup status"
                                        options={generalFilters?.signup_staus}
                                        selectchange={(temp) => {
                                            setSelectedSignUpStatus(temp)
                                            _updateStore('signup', temp);
                                        }} />
                                </div>
                                : selectedSegment?.value === 5 ?
                                    <div className='col=12 mt-2 mb-3'>
                                        <label>Select rebalance status</label>
                                        <SelectBox
                                            value={selectedRebalanceStatus}
                                            placeholder="Choose rebalance status"
                                            options={generalFilters?.rebalance_status}
                                            selectchange={(temp) => {
                                                setSelectedRebalanceStatus(temp)
                                                _updateStore({ 'date': null, 'rebalance': temp });
                                                setSelectedRepeatDay(null);
                                            }} />
                                    </div>
                                    : <div className='col=12 mt-2 mb-3'>
                                        <label>Enter days</label>
                                        <div className='position-relative'>
                                            <Input
                                                placeholder="Enter elapsed days"
                                                type="number"
                                                value={selectedRepeatDay}
                                                className="e-notification-form-element"
                                                valueChange={(temp) => {
                                                    _updateStore('date', temp);
                                                    setSelectedRepeatDay(temp);
                                                }}
                                            />
                                            {
                                                selectedRepeatDay && (
                                                    <div className='e-not-search-btn' onClick={_getNotificationUsers}>
                                                        <img src={require('../../assets/images/notification/right-arrow.png').default} width="25px" />
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                        }
                    </>
                )
            }


            {
                sendLater === true && (
                    <div className='row pt-3 border-top'>
                        <div className='col-12 d-flex justify-content-between'>
                            <label className='me-5'>Schedule message</label>
                            <div className='d-flex align-items-center'>
                                <Toggle checked={isOneTime} onChange={(e) => {
                                    setIsOneTime(e.target.checked);
                                    _updateStore({ is_one_time: e.target.checked, frequency: null, start_date: null, end_date: null, time: null, week_day: null, month_day: null });
                                    setSelectedFrequency(null);
                                    setStartDate(null);
                                    setEndDate(null);
                                    setAddedTime(null);
                                    setSelectedWeekDay(null);
                                    setSelectedRepeatedDate(null);
                                    setRepeatedDate(null);
                                }} />
                                <span className={`${style.e_toggle_label} ps-2 `}>One time</span>
                            </div>
                        </div>
                        {
                            isOneTime === false && (
                                <div className='col-6 pb-4'>
                                    <label className='mb-1'>Select frequency</label>
                                    <SelectBox
                                        isSearchable={false}
                                        options={generalFilters?.repeat_frequency}
                                        placeholder="Select frequency"
                                        value={selectedFrequency}
                                        selectchange={(selected_value) => {
                                            setSelectedFrequency(selected_value);
                                            _updateStore('frequency', selected_value);
                                        }} />
                                </div>
                            )
                        }


                        <div className='col-6 pb-4'>
                            <label className='mb-1'>Start date</label>
                            <Datepicker
                                value={startDate}
                                disabledDate={(current) => current.isBefore(moment().startOf("day"))}
                                onChange={(value) => {
                                    setStartDate(value);
                                    _updateStore('start_date', value);
                                }}
                            />

                        </div>
                        {
                            isOneTime === false && (
                                <div className='col-6 pb-4'>
                                    <label className='mb-1'>End date</label>
                                    <Datepicker
                                        value={endDate}
                                        disabledDate={disabledDate}
                                        onChange={(value) => {
                                            setEndDate(value);
                                            _updateStore('end_date', value);
                                        }}
                                    />

                                </div>
                            )
                        }

                        <div className='col-6 pb-4'>
                            <label className='mb-1'>Add time</label>
                            <SelectBox
                                isSearchable={false}
                                options={_getAvailableTime(isOneTime)}
                                placeholder="Select time"
                                value={addedTime}
                                selectchange={(selected_value) => {
                                    setAddedTime(selected_value);
                                    _updateStore('time', selected_value);
                                }} />
                        </div>

                        {
                            selectedFrequency ?
                                <>
                                    {
                                        selectedFrequency.value === 1 ?
                                            <div className='col-6 pb-4'>
                                                <label className='mb-1'>Select week day</label>
                                                <SelectBox
                                                    isSearchable={false}
                                                    options={generalFilters?.repeat_day}
                                                    placeholder="Select week day"
                                                    value={selectedWeekDay}
                                                    selectchange={(selected_value) => {
                                                        setSelectedWeekDay(selected_value);
                                                        _updateStore('week_day', selected_value);
                                                    }} />
                                            </div>
                                            : selectedFrequency.value === 2 ?
                                                <div className="col-6 position-relative pb-4">
                                                    <label>Frequency</label>
                                                    <div className="cursor-pointer" onClick={() => setShowDropdown(true)}>
                                                        <SelectBox isDisabled
                                                            value={repeatedDate}
                                                            isSearchable={false}
                                                            placeholder="Select Day"
                                                            className=''
                                                        />
                                                    </div>
                                                    {
                                                        showDropdown ?
                                                            <div className='position-absolute e-date-dropdown p-3' ref={searchRef} >
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <h6>Select date</h6>
                                                                    <button id="close-sip"
                                                                        type="button"
                                                                        className="btn-close"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() => setShowDropdown(false)} >
                                                                    </button>
                                                                </div>

                                                                <div className="d-flex flex-wrap text-center">
                                                                    {NORMALIZED_SIP_DATES.map((item, key) => (
                                                                        <div className={` d-flex align-items-center justify-content-center e-cart-date ${selectedRepeatedDate === item ? "e-active-date" : "e-cart-date color-eerie-black cursor-pointer"}`}
                                                                            key={key}
                                                                            onClick={() => {
                                                                                setSelectedRepeatedDate(item)
                                                                            }} >
                                                                            {item}
                                                                        </div>
                                                                    ))}

                                                                </div>



                                                                <div className='mt-3 col-12 mx-auto'>
                                                                    <PrimaryBtn name="Confirm date"
                                                                        className="padding-10px-tb w-100 color"
                                                                        handleClick={() => {
                                                                            setRepeatedDate({
                                                                                label: _formatSip(selectedRepeatedDate),
                                                                                value: selectedRepeatedDate
                                                                            });
                                                                            _updateStore('month_day', selectedRepeatedDate);
                                                                            setShowDropdown(false)
                                                                        }} />
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                                :
                                                null

                                    }
                                </>
                                : null
                        }

                    </div>
                )
            }

            <div style={{ minHeight: '60px' }}>
                {
                    notificationListLoader ?
                        <div className='col-12'>
                            <img src={LoaderImg} alt="" height="40px" width="100%" style={{ objectFit: "contain", marginTop: "20px" }} />
                        </div>
                        :
                        notificationUsers?.length ?
                            <div className='col-12 e-view-users-table'>
                                <div className='d-flex align-items-center cursor-pointer' style={{ width: 'max-content' }}
                                    onClick={() => setOpenUsersList(!openUsersList)}>
                                    <TextBtn className='mt-1 me-1'
                                        name={`Eligible users(${notificationUsers.length})`}
                                        handleClick={() => { }} />
                                    <div className='e-user-arrow-down'
                                        data-direction={openUsersList}></div>
                                </div>
                                <>
                                    {
                                        openUsersList === true ?
                                            <DataTable
                                                pagination={false}
                                                columns={TABLE_COLUMN}
                                                data={notificationUsers}
                                                paginationServer={true}
                                                selectableRows={false}
                                            />
                                            : null
                                    }
                                </>

                            </div>
                            : null
                }
            </div>

            {/* Buttons */}
            <div className="col-lg-12 d-flex justify-content-start text-left mb-3 mt-4">
                {
                    props.editableData && props.sendAgain === false ? (
                        <>
                            {(() => {
                                const segmentValid =
                                    type === 3
                                        ? (
                                            selectedSegment?.value === 1
                                                ? selectedSignUpStatus
                                                : selectedSegment?.value === 5
                                                    ? selectedRebalanceStatus
                                                    : selectedRepeatDay
                                        )
                                        : true;

                                const isValid =
                                    subject !== "" &&
                                    (
                                        emailContentType === "BODY_CONTENT"
                                            ? emailContent
                                            : htmlFile
                                    ) &&
                                    (
                                        type === 2
                                            ? userUrl
                                            : type === 3
                                                ? selectedSegment
                                                : type === 4
                                                    ? (() => {
                                                        const hasEmpty = customEmails.some(e => (e || "").trim() === "");
                                                        const filled = customEmails.filter(e => (e || "").trim() !== "");
                                                        const allValid = filled.every(e => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || "").trim()));
                                                        return !hasEmpty && filled.length > 0 && allValid;
                                                    })()
                                                    : true
                                    ) &&
                                    Boolean(segmentValid);

                                return isValid ? (
                                    <PrimaryBtn
                                        name="Save"
                                        className={
                                            loader
                                                ? "e-notification-form-btn e-btn-loader e-disabled"
                                                : "e-notification-form-btn"
                                        }
                                        handleClick={_showConfirmation}
                                    />
                                ) : (
                                    <PrimaryBtn name="Save" className="e-disabled" />
                                );
                            })()}
                        </>
                    ) : (
                        <>
                            {(() => {
                                const segmentValid =
                                    type === 3
                                        ? (
                                            selectedSegment?.value === 1
                                                ? selectedSignUpStatus
                                                : selectedSegment?.value === 5
                                                    ? selectedRebalanceStatus
                                                    : selectedRepeatDay
                                        )
                                        : true;

                                /* -------- Schedule validation (INLINE & SAFE) -------- */
                                const isScheduleValid = !sendLater
                                    ? true
                                    : isOneTime
                                        ? Boolean(startDate && addedTime)
                                        : Boolean(
                                            startDate &&
                                            endDate &&
                                            addedTime &&
                                            selectedFrequency &&
                                            (
                                                selectedFrequency.value === "weekly"
                                                    ? selectedWeekDay
                                                    : selectedFrequency.value === "monthly"
                                                        ? selectedRepeatedDate
                                                        : true
                                            )
                                        );

                                const isValid =
                                    subject !== "" &&
                                    (
                                        emailContentType === "BODY_CONTENT"
                                            ? emailContent
                                            : htmlFile
                                    ) &&
                                    (
                                        type === 2
                                            ? userUrl
                                            : type === 3
                                                ? selectedSegment
                                                : type === 4
                                                    ? (() => {
                                                        const hasEmpty = customEmails.some(e => (e || "").trim() === "");
                                                        const filled = customEmails.filter(e => (e || "").trim() !== "");
                                                        const allValid = filled.every(e => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || "").trim()));
                                                        return !hasEmpty && filled.length > 0 && allValid;
                                                    })()
                                                    : true
                                    ) &&
                                    Boolean(segmentValid) &&
                                    sendLater === false;

                                return isValid ? (
                                    <PrimaryBtn
                                        name="Send now"
                                        className={
                                            loader
                                                ? "e-notification-form-btn e-btn-loader e-disabled"
                                                : "e-notification-form-btn"
                                        }
                                        handleClick={_showConfirmation}
                                    />
                                ) : (
                                    <>
                                        {
                                            sendLater ? (
                                                <SecondaryBtn
                                                    name="Cancel scheduling"
                                                    handleClick={() => setSendLater(false)}
                                                />
                                            ) : (
                                                <PrimaryBtn
                                                    name="Send now"
                                                    className="e-disabled"
                                                />
                                            )
                                        }
                                    </>
                                );
                            })()}

                            {
                                sendLater === false ? (
                                    <SecondaryBtn
                                        name="Send later"
                                        className="ms-3"
                                        handleClick={() => {
                                            setSendLater(true);
                                            _updateStore("send_later", true);
                                        }}
                                    />
                                ) : (
                                    <>
                                        {(() => {
                                            const isScheduleValid = isOneTime
                                                ? Boolean(startDate && addedTime)
                                                : Boolean(
                                                    startDate &&
                                                    endDate &&
                                                    addedTime &&
                                                    selectedFrequency &&
                                                    (
                                                        selectedFrequency.value === "weekly"
                                                            ? selectedWeekDay
                                                            : selectedFrequency.value === "monthly"
                                                                ? selectedRepeatedDate
                                                                : true
                                                    )
                                                );
                                            const audienceValid = type !== 4 ? true : (() => {
                                                const hasEmpty = customEmails.some(e => (e || "").trim() === "");
                                                const filled = customEmails.filter(e => (e || "").trim() !== "");
                                                const allValid = filled.every(e => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || "").trim()));
                                                return !hasEmpty && filled.length > 0 && allValid;
                                            })();

                                            return isScheduleValid && audienceValid ? (
                                                <PrimaryBtn
                                                    name="Schedule now"
                                                    className={
                                                        loader
                                                            ? "e-notification-form-btn e-btn-loader ms-3 e-disabled"
                                                            : "e-notification-form-btn ms-3"
                                                    }
                                                    handleClick={_showConfirmation}
                                                />
                                            ) : (
                                                <PrimaryBtn
                                                    name="Schedule now"
                                                    className="ms-3 e-disabled"
                                                />
                                            );
                                        })()}
                                    </>
                                )
                            }
                        </>
                    )
                }
            </div>




            {/*--------- error toast --------*/}
            {
                error !== null ?
                    <Toast
                        data={error}
                        type="error"
                        id="1"
                        onClose={() => {
                            setError(null);
                        }}
                    />
                    :
                    null
            }


            {/*--------- success toast --------*/}
            {
                success !== null ?
                    <Toast
                        data={success}
                        type="success"
                        id="2"
                        onClose={() => {
                            setSuccess(null);
                        }}
                    />
                    :
                    null
            }
            <NotificationConfirm
                type={type}
                notificationType={4}
                sendLater={sendLater}
                Confirm={() => {
                    _sendGlobalNotification();
                }} />
        </div>
    );
};

export default EmailMessage;
